import { Label } from "@/shared/components/ui/label";

/**
 * Shared UI wrappers for Merchant Dashboard forms (Deposit/Withdrawal).
 * Ensures consistent styling across all form-based screens.
 */

export function SectionCard({ icon: Icon, title, children }) {
  return (
    <div className="bg-white rounded-2xl p-4 sm:p-6 border border-slate-100 shadow-sm transition-all hover:shadow-md">
      <div className="flex items-center gap-2 mb-4">
        <Icon className="h-5 w-5 text-slate-700" />
        <h3 className="font-semibold text-slate-900">{title}</h3>
      </div>
      {children}
    </div>
  );
}

export function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-xs text-red-500 mt-1">{message}</p>;
}

export function FormRow({ id, label, error, icon: Icon, hint, children }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      {Icon ? (
        <div className="relative">
          <Icon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          {children}
        </div>
      ) : (
        children
      )}
      {hint && <p className="text-xs text-slate-400">{hint}</p>}
      <FieldError message={error} />
    </div>
  );
}
